<div class="password-change-overlay">
    <p-dialog
        header="Update Password"
        [modal]="false"
        visible="true"
        [closable]="false"
        [style]="{ width: '25vw', 'min-width': '25vw' }"
        [baseZIndex]="99999"
        [draggable]="false"
        [resizable]="false"
        [closeOnEscape]="false"
        [dismissableMask]="false"
    >
        <div class="grid justify-self-center mt-2">
            <div class="col-12 mb-3">
                <p-message class="full-width-message" severity="info" [text]="infoMessage" [hidden]="!infoMessage"></p-message>
            </div>
            <div class="col-12 mb-3" *ngIf="updateResponseStatusCode == '1'">
                <p-message class="full-width-message" severity="success" text="Password successfully updated."></p-message>
            </div>
            <div class="col-12 mb-3" *ngIf="updateResponseStatusCode == '3'">
                <p-message class="full-width-message" severity="error" [text]="updateResponseMessage"></p-message>
            </div>
            <div class="col-12 mt-2 mb-3">                
                <div class="w-full flex items-center">                   
                    <p-floatLabel variant="on" class="w-full">
                        <input pInputText id="old" fluid type="password" [(ngModel)]="oldPassword" (blur)="validateOldPassword()">
                        <label for="old">Current password</label>
                    </p-floatLabel>  
                    <i for="old" *ngIf="validateOldPasswordResponse && oldPassword != ''" class="pi pi-check text-green-500 ml-2 align-self-center"></i>
                    <i for="old" *ngIf="!validateOldPasswordResponse && oldPassword != ''" [title]="oldPasswordIconTooltip" class="pi pi-times text-red-500 ml-2 align-self-center"></i>                 
                </div>  
                            
            </div>
            <div class="col-12 mb-3">
                <div class="w-full flex items-center">
                    <p-floatLabel variant="on" class="w-full">
                        <p-password fluid id="new" styleClass="w-full" [(ngModel)]="newPassword" (ngModelChange)="onNewPasswordInput()" [feedback]="true" [toggleMask]="true" [promptLabel]="'Enter a password'" [weakLabel]="'Weak'" [mediumLabel]="'Medium'" [strongLabel]="'Strong'">
                        </p-password>
                        <label for="new">New password</label>
                    </p-floatLabel>
                    <i for="new" *ngIf="newPasswordErrorIcon == false" class="pi pi-check" class="pi pi-check text-green-500 ml-2 align-self-center"></i>
                    <i for="new" *ngIf="newPasswordErrorIcon == true && newPassword != ''" [title]="newPasswordIconTooltip" class="pi pi-times" class="pi pi-times text-red-500 ml-2 align-self-center"></i>
                </div>
            </div>
            <div class="col-12 mb-3">
                <div class="w-full flex items-center">
                    <p-floatLabel variant="on" class="w-full">
                        <input pInputText id="confirm" class="w-full" type="password" [(ngModel)]="confirmPassword" (ngModelChange)="onConfirmPasswordInput()">
                        <label for="confirm">Confirm new password</label>
                    </p-floatLabel>
                    <i for="confirm" *ngIf="confirmPasswordErrorIcon == false" class="pi pi-check" class="pi pi-check text-green-500 ml-2 align-self-center"></i>
                    <i for="confirm" *ngIf="confirmPasswordErrorIcon == true && confirmPassword != ''" [title]="confirmPasswordIconTooltip" class="pi pi-times" class="pi pi-times text-red-500 ml-2 align-self-center"></i>
                </div>
            </div>
            <div class="col-12 justify-content-end flex">
                <button *ngIf="updateResponseStatusCode == '1'" pButton pRipple type="button" class="p-button-primeary mr-2" label="Login" (click)="gotoLogin()" title="Navigate to login page"></button>
                <button pButton pRipple type="button" class="p-button-secondary" label="Update Password" [disabled]="!updateBtnEnabled" (click)="changePassword()"></button>
            </div>
        </div>
    </p-dialog>
</div>
